import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formatter", "parser", "precision", "value", "error", "max", "min", "maxFractionDigits", "onBlur", "onChange", "onFocus", "onRawValueChange", "onKeyUp", "separator", "defaultValue", "disabled", "inputRef", "placeholder", "readOnly", "styled", "use", "autoFocus", "disableFocusStyles"];
import { filterProps } from '../../../utils/filterProps';
import { NumberInput } from '../NumberInput';
import { useDisableFocusStyles } from '../../../hooks/useDisableFocusStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export const PercentageInput = _ref => {
  let {
      formatter,
      parser,
      precision,
      value,
      error = false,
      max,
      min,
      maxFractionDigits,
      onBlur,
      onChange,
      onFocus,
      onRawValueChange,
      onKeyUp,
      separator,
      defaultValue,
      disabled,
      inputRef,
      placeholder,
      readOnly,
      styled = true,
      use = 'default',
      autoFocus,
      disableFocusStyles: disableFocusStylesProp
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const disableFocusStyles = useDisableFocusStyles(disableFocusStylesProp);
  const inputProps = Object.assign({}, domProps, tokenProps, {
    autoFocus,
    disabled,
    inputRef,
    placeholder,
    readOnly,
    styled,
    use,
    error,
    defaultValue
  });
  return /*#__PURE__*/_jsx(NumberInput, Object.assign({}, inputProps, {
    max: max,
    min: min,
    maxFractionDigits: maxFractionDigits,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onRawValueChange: onRawValueChange,
    onKeyUp: onKeyUp,
    separator: separator,
    value: value,
    formatter: formatter,
    parser: parser,
    precision: precision,
    formatStyle: "percentage",
    disableFocusStyles: disableFocusStyles
  }));
};
PercentageInput.displayName = 'PercentageInput';